import { Component, Input, OnInit } from '@angular/core';
import { OrderInfo } from '../../_model/OrderInfo';
import { SourceInfo } from '../../_model/SourceInfo';
import { ReportService } from '../../inservice/report.service';
import { Utils } from '../../_util/utils';

@Component({
  selector: 'app-template-q',
  templateUrl: './template-q.component.html',
  styleUrls: ['./template-q.component.scss']
})
export class TemplateQComponent implements OnInit {
  // selectedPhotos=[];
  pageNo = [];
  // @Input() source: SourceInfo;
  // @Input() orderInfo: OrderInfo;
  // @Input() index: number;
  // @Input() baseMapChecked:boolean;
  @Input() photos: Array<any>;
  @Input() photoslength: number; // this is used to track updates to number of photos, since this.photos is hooked by reference so changes are not caught by ngOnChanges
  @Input() showDateDirectionLocation: boolean;

  w: number;
  h: number;
  constructor(public reportService: ReportService) { }

  ngOnInit() {
    this.w = Math.floor(Utils.mmToPx(216, this.reportService.dpi)); console.log(this.w);
    this.h = Math.floor(Utils.mmToPx(279, this.reportService.dpi)); console.log(this.h);
    this.pageNo = [];
    let total = Math.ceil(this.photos.length / 4);
    for (let i = 0; i < total; i++) {
      this.pageNo.push(i * 4);
    }
    console.log(this.pageNo);
    //   let mobileNotes=this.orderInfo.MOBILE_NOTES;
    //    for(let photo of this.reportService.photos){console.log(photo)

    //        let index=mobileNotes.findIndex(m=>m.MOBILE_NOTES_ID==photo.id);console.log(index)
    //       let photoSrc=mobileNotes[index].MEDIAS[photo.index]; console.log(photoSrc);
    //       let photoInfo={
    //         photoId:photoSrc.MOBILE_MEDIAS_ID,
    //         photoTag:mobileNotes[index].NOTE_TAG,
    //         photoDate:photoSrc.MEDIA_ADDED,
    //         comment:photoSrc.MEDIA_COMMENT, 
    //         url:photoSrc.MEDIA_URL,
    //         title:photoSrc.MEDIA_TITLE,
    //     }
    //     this.selectedPhotos.push(photoInfo);


    // }
  }

  ngOnChanges() {
    if (this.pageNo.length !== Math.ceil(this.photos.length / 2)){
      this.pageNo = [];
      let total = Math.ceil(this.photos.length / 4);
      for (let i = 0; i < total; i++) {
        this.pageNo.push(i * 4);
      }
    }
  }
}
